export default __webpack_public_path__ + "static/media/ToyotaType-Semibold.5ae0203b.eot";